// esicDisablementTypeAction.ts

import { createAsyncThunk } from "@reduxjs/toolkit";
import payrollServiceApiInstance from "../../../../../../config/payrollApiConfig";
import {EsicDisablementType,CreateEsicDisablementTypePayload,UpdateEsicDisablementTypePayload,} from "./disablementTypes";

// Create
export const createEsicDisablementType = createAsyncThunk<
    { id: number },
    CreateEsicDisablementTypePayload
>("esicDisablementType/create", async (payload, { rejectWithValue }) => {
    try {
        const response = await payrollServiceApiInstance.post("/esic-disablement-type", payload);
        return response.data.data;
    } catch (error: any) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

// Get All
export const fetchEsicDisablementTypeList = createAsyncThunk<
    EsicDisablementType[]
>("esicDisablementType/fetchAll", async (_, { rejectWithValue }) => {
    try {
        const response = await payrollServiceApiInstance.get("/esic-disablement-type");
        return response.data.data;
    } catch (error: any) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

// Get By Id
export const fetchEsicDisablementTypeById = createAsyncThunk<
    EsicDisablementType,
    number
>("esicDisablementType/fetchById", async (id, { rejectWithValue }) => {
    try {
        const response = await payrollServiceApiInstance.get(`/esic-disablement-type/${id}`);
        return response.data.data;
    } catch (error: any) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

// Update
export const updateEsicDisablementType = createAsyncThunk<
    any, // or a more specific type
    { id: number; payload: UpdateEsicDisablementTypePayload }>(
    "esicDisablementType/update",
    async ({ id, payload }, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.put(`/esic-disablement-type/${id}`, payload);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


// Delete
export const deleteEsicDisablementType = createAsyncThunk<void, number>(
    "esicDisablementType/delete",
    async (id, { rejectWithValue }) => {
        try {
            await payrollServiceApiInstance.delete(`/esic-disablement-type/${id}`);
        } catch (error: any) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
